import { Action } from '@ngrx/store';
import { SubmissionApprovalRequest } from './flow-manager-core';
import { FlowDeployState } from './state/Flow';

/* Defining the type of the button. */
export enum ConfirmBtnEnum {
    primary = 'primary',
    secondary = 'secondary',
}

/* Defining the interface for the modals. */
export interface ButtonModalConfig {
    name?: string;
    activeName?: string;
    style?: ConfirmBtnEnum;
}

export interface ConfirmModalConfig {
    modalState: boolean;
    title: string;
    body: string;
    button: { [key: string]: ButtonModalConfig };
    callBackType?: { [key: string]: Action };
    error?: string;
    deployState: { type?: FlowDeployState, actionDeploy: boolean };
}

export interface SubmissionsApprovalRequestConfig {
    flowName: string;
    env: string;
    submissionsApprovalRequest: SubmissionApprovalRequest;
}
